export default "__VITE_ASSET__5d1909f3__"